import {Component, OnInit, ViewChild} from '@angular/core';
import {Subject, Subscription} from "rxjs";
import {DataTableDirective} from "angular-datatables";
import {UserDataStoreService} from "../services/user-data-store.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ParticipantViewModel} from "../models/participant-view-model";
import { ParticipantService } from "../services/participant.service";
import { SinkNodeMappingViewComponent } from "./sink-node-mapping-view/sink-node-mapping-view.component";
import { ToastrService } from 'ngx-toastr';
import { PermissionEnum } from '../services/guards/permissions';
import {AuthenticationService} from "../services/authentication.service";

@Component({
  selector: 'app-sink-node-mapping-management',
  templateUrl: './sink-node-mapping-management.component.html',
  styleUrls: ['./sink-node-mapping-management.component.scss']
})
export class SinkNodeMappingManagementComponent implements OnInit {
  public dtOptions: DataTables.Settings = {};
  public participants: ParticipantViewModel[] = [];
  public dtTrigger: Subject<boolean> = new Subject();
  public canEdit: boolean;


  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;


  constructor(private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _participantService: ParticipantService,
    private _toastService: ToastrService) {
    this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditParticipantConfiguration], []);
    
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
  }

  public async ngAfterViewInit(): Promise<void> {
    await this.init();
  }

  private async init(): Promise<void> {

    this.participants = await this._participantService.GetAllParticipants();
    this.dtTrigger.next();
  }

  private resetDatatable(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  public async  syncParticipants(): Promise<void>{
    await this._participantService.Sync();
    this.participants = await this._participantService.GetAllParticipants();
    this.resetDatatable();
  }

  public async editParticipant(participant: ParticipantViewModel): Promise<void> {
    if (!this.canEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      const modalRef = this._modalService.open(SinkNodeMappingViewComponent, {
        windowClass: 'modal-fade-in',
        centered: false,
        size: 'xl',
        backdrop: 'static'
      });
      modalRef.componentInstance.participant = participant;
      await modalRef.result;

      this.participants = await this._participantService.GetAllParticipants();
      this.resetDatatable();
    }
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
}
